import LegacyMedProjectList from '../components/MedProject/LegacyProjects/LegacyMedProjectList';
import LegacyMedProject from '../components/MedProject/LegacyProjects/LegacyMedProject';
import RelatedProjList from '../components/MedProject/LegacyProjects/RelatedProjects/RelatedProjects';

import MedProjects from '../components/MedProject/MedProjects/MedProjects';

const medProjectRoutes = [
    // 原关联项目用医项目
    { path: 'proj/list', element: <LegacyMedProjectList /> },
    { path: 'proj/new', element: <LegacyMedProject /> },
    { path: 'proj/:id', element: <LegacyMedProject /> },
    { path: 'proj/:id/related-projects', element: <RelatedProjList /> },

    // 正式版医项目：列表由 MainLayout 承载；新增/详情均由顶层 `/medproject/projects/:projectId/*` + WorkspaceLayout 提供（:projectId = 'new' 即为新增场景）
    { path: 'projects', element: <MedProjects /> },
];

export default medProjectRoutes;
